import { t } from "@/i18n-js/instance";
import { useAccessGroups } from "@circle-react/hooks/accessRegistry/useAccessGroups";
import { Button } from "@circle-react-uikit/Button";
import { Loader } from "@circle-react-uikit/Loader";
import { StepperDots } from "@circle-react-uikit/StepperDots";
import { FormItems } from "./FormItems";
import { Preview } from "./Preview";
import { SubscriptionGroupChooser } from "./SubscriptionGroupChooser";
import { useMigrationForm } from "./hooks/useMigrationForm";

const i18nBase = "settings.access_groups.paywall_migration.modal";

export const FormContent = ({
  closeModals,
  shouldShowPaywallGroupSelector,
  currencyId,
}: {
  closeModals: () => void;
  currencyId: number;
  shouldShowPaywallGroupSelector: boolean;
}) => {
  const { data: accessGroups, isLoading: isLoadingAccessGroups } =
    useAccessGroups();

  const {
    handleStepChange,
    selectedStepIndex,
    isReviewChangesStep,
    handleFormNavigation,
    isPaywallGroupSelectionStep,
    isAccessGroupConfigurationStep,
    totalSteps,
    shouldShowBackButton,
  } = useMigrationForm({
    closeModals,
    shouldShowPaywallGroupSelector,
  });

  if (isLoadingAccessGroups) {
    return <Loader />;
  }

  const renderContent = () => {
    if (isPaywallGroupSelectionStep && shouldShowPaywallGroupSelector) {
      return <SubscriptionGroupChooser currencyId={currencyId} />;
    }
    if (isAccessGroupConfigurationStep) {
      return <FormItems accessGroups={accessGroups} />;
    }
    return <Preview />;
  };

  return (
    <div className="px-8">
      <div className="h-[526px]">
        <div className="flex-1 overflow-y-auto py-6">{renderContent()}</div>
      </div>

      <div className="my-2 flex">
        <div className="flex-1 justify-start">
          {shouldShowBackButton && (
            <Button
              type="button"
              variant="secondary"
              className="!py-2"
              onClick={() => handleStepChange(selectedStepIndex - 1)}
            >
              {t([i18nBase, "form.buttons.back"])}
            </Button>
          )}
        </div>
        <div className="flex justify-center">
          <StepperDots totalDots={totalSteps} activeDot={selectedStepIndex} />
        </div>
        <div className="flex flex-1 justify-end">
          <Button
            type="button"
            variant="circle"
            className="!py-2"
            onClick={handleFormNavigation}
          >
            {isReviewChangesStep
              ? t([i18nBase, "form.buttons.confirm"])
              : t([i18nBase, "form.buttons.next"])}
          </Button>
        </div>
      </div>
    </div>
  );
};
